import { render, staticRenderFns } from "./deductList.vue?vue&type=template&id=8b072630&scoped=true"
import script from "./deductList.vue?vue&type=script&lang=js"
export * from "./deductList.vue?vue&type=script&lang=js"
import style0 from "./deductList.vue?vue&type=style&index=0&id=8b072630&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b072630",
  null
  
)

export default component.exports